/**
 * Homepage character roster - the six faces shown on the hero lineup.
 *
 * Kept client-side on purpose: the homepage should render instantly without
 * waiting on a socket handshake. Mirror only the fields the marketing shell
 * needs (identity, poster cutout, short billing line). Gameplay-critical
 * fields (HP, attack, moves) still come from the server at match time.
 *
 * Fields:
 *   - id:               stable slug
 *   - name:             display name shown below the cutout
 *   - billing:          short role descriptor ("The Boss")
 *   - cutoutUrl:        path under /characters/cutouts/ (rewritten at runtime
 *                       when REACT_APP_CUTOUT_BASE_URL points at cloud storage)
 *   - from:             movie + year (useful for tooltips)
 *
 *   - cutoutScale:      height multiplier for the rendered cutout (default 1).
 *                       Used to match visual height across sources with
 *                       different aspect ratios / crops.
 *   - cutoutTranslateY: vertical offset as a % of the cutout's own height
 *                       (default '0%'). Positive = push DOWN. Needed for
 *                       square-canvas sources where the subject is centered
 *                       (transparent padding below the feet) - we shift the
 *                       image down so the visible feet re-align with the
 *                       slot's bottom edge.
 */

export const homepageCharacters = [
    {
        id: 'sivaji',
        name: 'Sivaji',
        billing: 'The Boss',
        cutoutUrl: '/characters/cutouts/sivaji.png',
        from: 'Sivaji (2007)',
        cutoutScale: 1.0,
    },
    {
        id: 'anniyan',
        name: 'Anniyan',
        billing: 'The Vigilante',
        cutoutUrl: '/characters/cutouts/anniyan.png',
        from: 'Anniyan (2005)',
        cutoutScale: 1.0,
    },
    {
        id: 'rocky',
        name: 'Rocky Bhai',
        billing: 'The Gangster',
        cutoutUrl: '/characters/cutouts/rocky.png',
        from: 'KGF (2018)',
        cutoutScale: 1.0,
    },
    {
        id: 'kabilan',
        name: 'Kabilan',
        billing: 'The Boxer',
        cutoutUrl: '/characters/cutouts/kabilan.png',
        from: 'Sarpatta Parambarai (2021)',
        cutoutScale: 1.0,
    },
    {
        id: 'jagadeesh',
        name: 'Jagadeesh',
        billing: 'The Captain',
        cutoutUrl: '/characters/cutouts/jagadeesh.png',
        from: 'Thuppakki (2012)',
        cutoutScale: 1.0,
    },
    {
        id: 'devasena',
        name: 'Devasena',
        billing: 'The Princess',
        cutoutUrl: '/characters/cutouts/devasena.png',
        from: 'Baahubali (2015)',
        cutoutScale: 1.0,
    },
];

// Convenience subset for the homepage hero - all 6 (we display all of them
// in an overlapping lineup, with the center three scaled up).
export const heroLineup = homepageCharacters;

export default homepageCharacters;
